import { FontStyleSettings } from "./types";

export const defaultDraftStyles: FontStyleSettings = {
  fontFamily: "Courier",
  fontSize: 10,
  // Darker green for readability on white documents (client feedback: the
  // previous #2E8B57 sea-green was too light to read comfortably).
  fontColor: "#1F6B3E",
  bold: false,
  italic: true,
  highlightColor: null,
};

export const defaultConfirmedStyles: FontStyleSettings = {
  fontFamily: "Arial",
  fontSize: 10,
  fontColor: "#141414",
  bold: false,
  italic: false,
  highlightColor: null,
};

export const defaultUserStyles: FontStyleSettings = {
  fontFamily: "Verdana",
  fontSize: 10,
  fontColor: "#FFFFFF",
  bold: true,
  italic: false,
  highlightColor: "#2C5AA5",
};
